import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const sections = [
  {
    title: 'Company',
    links: [
      { to: '/company', label: 'Company' },
      { to: '/about-us', label: 'About Us' },
      { to: '/contact', label: 'Contact' },
      { to: '/submit-tool', label: 'Submit Tool (coming soon)' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { to: '/disclaimer', label: 'Disclaimer' },
      { to: '/privacy-policy', label: 'Privacy Policy' },
      { to: '/terms-of-service', label: 'Terms of Service' },
      { to: '/sitemap', label: 'Sitemap' },
    ],
  },
  {
    title: 'Core',
    links: [
      { to: '/', label: 'Home' },
      { to: '/categories', label: 'Categories' },
      { to: '/find', label: 'Find My Tools' },
      { to: '/compare', label: 'Compare' },
      { to: '/consulting', label: 'Consulting' },
      { to: '/faq', label: 'FAQ' },
    ],
  },
];

const SitemapPage = () => {
  return (
    <div className="min-h-screen pt-24 page-bg-shell page-bg-grid" data-testid="sitemap-page">
      <Helmet>
        <title>Sitemap | Wowrolla</title>
        <meta name="description" content="Browse all key pages on Wowrolla including company, legal, and platform sections." />
      </Helmet>

      <section className="container mx-auto px-6 pb-14 max-w-5xl">
        <h1 className="text-4xl font-black mb-6" style={{ color: 'var(--text-primary)', fontFamily: 'Unbounded, sans-serif' }}>
          Sitemap
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {sections.map((section) => (
            <div key={section.title} className="terminal-grid p-6">
              <h2 className="text-xl font-bold mb-3" style={{ color: 'var(--text-primary)' }}>{section.title}</h2>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link.to}>
                    <Link to={link.to} className="text-sm hover:underline" style={{ color: 'var(--accent-primary)' }}>
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default SitemapPage;

